<template>
  <div class="home-screen">
    <div class="video-view">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide slide-cnt"
            v-for="(newsItem, i) in newsItems"
            :key="i"
          >
            <div class="screen-slide" v-if="currentSlideHome == i">
              <div class="article-img">
                <img :src="newsItem.postImg" width="500" height="350" alt="" />
              </div>
              <div class="article-textbox">
                <h2>{{ newsItem.postTitle }}</h2>
                <p>{{ newsItem.shortDesc }}</p>
                <div class="text-provider">
                  <span>{{ newsItem.newsPartner }}</span> पर / कुछ
                  {{ newsItem.timeGo }}
                </div>
                <div class="dtl-btn-blk">
                  <div class="share-btn" @click="share(newsItem)">
                    <share-icon />शेयर
                  </div>

                  <button
                    class="news-detail-btn"
                    @click="handleOpen(newsItem.postUrl, i)"
                  >
                    और पढ़ें...
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader91 v-if="isLoading" />
  </div>
</template>

<script>
import AudioPlayer from './AudioPlayer';
import HomeIcon from './svgIcons/HomeIcon';
import ProfileIcon from './svgIcons/ProfileIcon';
import PlusIcon from './svgIcons/PlusIcon';
import HeartIcon from './svgIcons/HeartIcon';
import CommentIcon from './svgIcons/CommentIcon';
import ShareIcon from './svgIcons/ShareIcon';
import ArrowTickIcon from './svgIcons/ArrowTickIcon';
import PostWallIcon from './svgIcons/PostWallIcon';
import { BASE_API } from '../utils/constants';

export default {
  name: 'home',

  components: {
    AudioPlayer,
    HomeIcon,
    ProfileIcon,
    PlusIcon,
    HeartIcon,
    CommentIcon,
    ShareIcon,
    ArrowTickIcon,
    PostWallIcon,
  },

  data() {
    return {
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
      isLoading: false,
      xauthid: this.$cookies.get('X-Auth-Id'),
      xauthtoken: this.$cookies.get('X-Auth-Token'),
      liked: false,
      followed: false,
      showCommentModal: false,
      currentVideoId: 1,
      commentKey: 1,
      comments: [],
      // swiper: null,
      isLoadingLike: false,
      newsItems: [
        {
          postImg: `https://spiderimg.amarujala.com/assets/images/2021/05/20/750x506/arvind-kejriwal_1621511564.jpeg`,
          postTitle: `केजरीवाल ने कहा- जरूरत पड़ी तो दिल्ली में भी ब्लैक फंगस को महामारी घोषित करेंगे`,
          shortDesc: `देश में कोरोना महामारी की दूसरी लहर का कहर जारी है। कोविड से होने वाली मौतों की संख्या में लगातार बढ़ोतरी से दहशत का माहौल है। लगातार बढ़ते कोरोना मरीजों की वजह से देश भर के अस्पतालों में बेड, वेंटिलेटर, रेमडेसिविर और ऑक्सीजन की किल्लत जारी है। सैकड़ों लोग बिना इलाज के ही दम तोड़ रहे हैं। यूपी, दिल्ली, महाराष्ट्र, मध्यप्रदेश समेत ज्यादातर राज्यों में तमाम पाबंदियां लागू हैं। पिछले 24 घंटे में 2.76 लाख नए कोरोना मरीज मिले हैं और 3,874 की जान चली गई है।`,
          postUrl: `https://www.amarujala.com/live/india-news/india-coronavirus-covid-19-cases-today-live-updates-news-on-20th-may-2021-corona-new-cases-and-death-vaccine-vaccination-delhi-up-maharashtra-lockdown-oxygen-remdesivir?src=top-lead`,
          newsPartner: 'Amar Ujala',
          timeGo: 'सेकंड',
        },

        {
          postImg: `https://images.bhaskarassets.com/thumb/600x450/web2images/521/2021/05/20/1_1621508159.jpg`,
          postTitle: `गुजरात के हजारों मछुआरों की रोजी-रोटी छिनी:जाफराबाद पोर्ट पर खड़ी मछुआरों की 150 नावें ताऊ ते तूफान में डूबीं, एक बोट से पलते हैं 100 परिवार`,
          shortDesc: `तूफान ताऊ-ते ने सौराष्ट्र के तटीय क्षेत्रों में बहुत नुकसान पहुंचाया है। दीव के नागवा बीच के साथ सबसे ज्यादा नुकसान जाफराबाद पोर्ट को भी हुआ है। यहां रखीं मछुआरों की सैकड़ों नावें टूट-फूटकर डूब गई हैं। नावों के खराब हो जाने से हजारों मछुआरों के सामने रोजी-रोटी का संकट खड़ा हो गया है। यहां एक नाव के नीचे से तीन शव भी बरामद हुए हैं, जिन्हें पोस्टमॉर्टम के लिए भेजा गया है।`,
          postUrl: `https://www.bhaskar.com/local/gujarat/news/boats-sank-in-jafrabad-in-the-wake-of-tau-te-hurricane-100-families-feed-in-one-boat-128508765.html`,
          newsPartner: 'Bhasker',
          timeGo: 'मिनट',
        },

        {
          postImg: `https://spiderimg.amarujala.com/assets/images/2021/05/20/750x506/health-ministry-pc_1621507914.jpeg`,
          postTitle: `स्वास्थ मंत्रालय ने कहा- देश के आठ राज्यों में 69 फीसदी मरीज, रिकवरी रेट में बढ़ोतरी`,
          shortDesc: `देश में कोरोना महामारी की दूसरी लहर का कहर जारी है। कोविड से होने वाली मौतों की संख्या में लगातार बढ़ोतरी से दहशत का माहौल है। लगातार बढ़ते कोरोना मरीजों की वजह से देश भर के अस्पतालों में बेड, वेंटिलेटर, रेमडेसिविर और ऑक्सीजन की किल्लत जारी है। सैकड़ों लोग बिना इलाज के ही दम तोड़ रहे हैं। यूपी, दिल्ली, महाराष्ट्र, मध्यप्रदेश समेत ज्यादातर राज्यों में तमाम पाबंदियां लागू हैं। पिछले 24 घंटे में 2.76 लाख नए कोरोना मरीज मिले हैं और 3,874 की जान चली गई है। `,
          postUrl: `https://www.amarujala.com/india-news/coronavirus-update-union-health-ministry-press-conference-joint-secretary-lav-agarwal-all-you-need-to-know-about?src=top-lead`,
          newsPartner: 'Amar Ujala',
          timeGo: 'घंटे',
        },

        {
          postImg: `https://www.jagranimages.com/images/newimg/20052021/20_05_2021-gold_rate_21660857.jpg`,
          postTitle: `सोने के दाम में आज हुआ बदलाव, जानें कितना हो गया है 10 ग्राम Gold का भाव`,
          shortDesc: `सोने एवं चांदी की कीमतों में गुरुवार को तेजी का रुख देखने को मिला। एचडीएफसी सिक्योरिटीज के मुताबिक राष्ट्रीय राजधानी दिल्ली में सोने के दाम में 237 रुपये प्रति 10 ग्राम की बढ़ोत्तरी दर्ज की गई। इससे शहर में सोने का रेट 47,994 रुपये प्रति 10 ग्राम पर पहुंच गया। सिक्योरिटीज के मुताबिक वैश्विक स्तर पर सोने के दाम में तेजी का असर घरेलू सर्राफा बाजारों में भी देखने को मिला। सिक्योरिटीज के मुताबिक इससे पिछले सत्र में यानी बुधवार को सोने का रेट 47,757 रुपये प्रति 10 ग्राम पर रहा था। `,
          postUrl: `https://www.jagran.com/business/biz-gold-price-today-gold-rate-changes-significantly-on-20-may-2021-know-the-latest-rate-of-10-gm-sona-and-chandi-ki-kimat-21660857.html?itm_source=website&itm_medium=homepage&itm_campaign=p1_component`,
          newsPartner: 'Jagran',
          timeGo: 'घंटे',
        },

        {
          postImg: `https://spiderimg.amarujala.com/assets/images/2021/05/09/750x506/bengal-cm-and-tmc-chief-mamata-banerjee_1620555333.jpeg`,
          postTitle: `तंज: कोरोना पर पीएम की बैठक पर मुख्यमंत्री ममता बनर्जी का आरोप-मुझे बोलने का मौका नहीं दिया गया`,
          shortDesc: `कोरोना संकट के मसले पर प्रधानमंत्री नरेंद्र मोदी ने गुरुवार को
                10 राज्यों के मुख्यमंत्री और 54 जिलाधिकारियों के साथ बैठक की।
                बैठक में पश्चिम बंगाल की मुख्यमंत्री ममता बनर्जी भी शामिल हुईं।
                बैठक के बाद ममता बनर्जी ने प्रेस कॉन्फ्रेंस कर पीएम मोदी पर
                निशाना साधा। ममता बनर्जी ने आरोप लगाया कि बैठक में सिर्फ भाजपा
                के कुछ मुख्यमंत्रियों ने अपनी बात रखी।, बाकी राज्यों के
                मुख्यमंत्री चुपचाप बैठे रहे। यहां तक कि मैं भी नहीं बोल पाई।
                ममता ने कहा कि उन्होंने अपने डीएम को इसलिए नहीं भेजा कि वह खुद
                ही दवाओं और टीकाकरण की मांग रखेंगी, लेकिन उन्हें बोलने का मौका
                नहीं दिया गया।`,
          postUrl:
            'https://www.amarujala.com/india-news/mamata-banerjee-slams-on-pm-modi-over-covid19-meeting?src=top-lead',
          newsPartner: 'Amar Ujala',
          timeGo: 'घंटे',
        },
      ],
    };
  },

  computed: {
    user: {
      get() {
        return this.$store.state.user;
      },
      set(newValue) {
        return this.$store.dispatch('setUser', newValue);
      },
    },
    selecteduser: {
      get() {
        return this.$store.state.selecteduser;
      },
      set(newValue) {
        return this.$store.dispatch('setSelectedUser', newValue);
      },
    },
    processing: {
      get() {
        return this.$store.state.processing;
      },
      set(newValue) {
        return this.$store.dispatch('setProcessing', newValue);
      },
    },
    homeMusic: {
      get() {
        return this.$store.state.homeMusic;
      },
      set(newValue) {
        return this.$store.dispatch('setHomeMusic', newValue);
      },
    },
    currentSlideHome: {
      get() {
        return this.$store.state.currentSlideHome;
      },
      set(newValue) {
        return this.$store.dispatch('setCurrentSlideHome', newValue);
      },
    },
    pageHome: {
      get() {
        return this.$store.state.pageHome;
      },
      set(newValue) {
        return this.$store.dispatch('setPageHome', newValue);
      },
    },
    isStartAutoplay: {
      get() {
        return this.$store.state.isStartAutoplay;
      },
      set(newValue) {
        return this.$store.dispatch('setIsStartAutoplay', newValue);
      },
    },
    swiper: {
      get() {
        return this.$store.state.swiper;
      },
      set(newValue) {
        return this.$store.dispatch('setswiper', newValue);
      },
    },
  },

  async mounted() {
    // this.getVideo();
    if (Object.keys(this.newsItems).length > 0) {
      setTimeout(
        (t) => {
          // t.swiper.destroy();
          t.callSwiper();
          // t.swiper.autoplay.stop();
          t.isLoading = false;
        },
        100,
        this
      );
    }
    //else {
    // this.createUser();
    // }
  },

  watch: {
    // isStartAutoplay() {
    //   if (this.isStartAutoplay) {
    //     this.swiper.autoplay.start();
    //   } else {
    //     this.swiper.autoplay.stop();
    //   }
    // },
  },

  methods: {
    handleOpen(postUrl, i) {
      this.currentSlideHome = i;
      window.open(postUrl);
      // this.$router.push({ name: 'NewsInDetail', query: item.link })
    },
    // async createUser() {
    //   this.isLoading = true;
    //   if (this.xauthid !== null) {
    //     if (Object.keys(this.user).length == 0) {
    //       let userDetails = await this.axios.post(
    //         `https://test.services-money91.com/api/createuser`,
    //         {
    //           xauthid: this.xauthid,
    //         }
    //       );

    //       if (userDetails !== null && userDetails.data.status) {
    //         this.user = userDetails.data.user;
    //         await this.getVideo();
    //         this.isLoading = false;
    //       } else {
    //         // this.$toast.bottom(userDetails.data.message);
    //         this.$toast.bottom('Network error!');
    //       }
    //     } else {
    //       this.isLoading = false;
    //     }
    //   }
    // },
    async share(newsItem, i) {
      try {
        JSBridgePlugin.downloadVideoAndShare(
          newsItem.postImg,
          newsItem.postTitle + ' via #news91 #mall91'
        );
      } catch (e) {
        console.log(e);
      }
    },
    async getPaginatedVideo() {
      this.isLoading = true;
      let vdo = await this.axios.get(
        `https://test.services-money91.com/news91/news91/v2/get_news/v3/${this.pageHome}/`,
        {
          xauthid: this.xauthid,
        }
      );
      if (vdo !== null && vdo.data) {
        this.homeMusic = [...this.homeMusic, ...vdo.data];
        this.isLoading = false;
      } else {
        this.$toast.bottom(vdo.data.message);
        this.isLoading = false;
      }
    },

    async getVideo() {
      if (this.swiper !== null) {
        this.swiper.destroy();
      }
      this.isLoading = true;
      let vdo = await this.axios.get(
        `${BASE_API}/news91/news91/v2/get_news/v3/0/`,
        {
          xauthid: this.xauthid,
          page: this.pageHome,
        }
      );
      if (vdo !== null && vdo.data) {
        this.homeMusic = vdo.data;
        setTimeout(
          (t) => {
            t.callSwiper();
            t.swiper.autoplay.stop();
            console.log('enter');
            t.isLoading = false;
          },
          100,
          this
        );
      } else {
        this.$toast.bottom(vdo.data.message);
        this.isLoading = false;
      }
    },

    // videoDuration(e) {
    //   console.log("sds");
    //   console.log(e);
    //   this.videoLength = e;
    // },

    callSwiper() {
      let t = this;
      t.swiper = new Swiper('.swiper-container', {
        direction: 'vertical',
        allowSlideNext: true,
        slidesPerView: 1,
        spaceBetween: 0,
        mousewheel: true,
        observer: true,
        initialSlide: t.currentSlideHome,
        // autoplay: {
        //   delay: 0,
        // },
      });
      // t.pageHome == 0
      // t.currentSlideHome = 0;
      t.currentVideoId = t.newsItems[t.currentSlideHome].id;
      // t.checkLiked(t.currentSlideHome);
      // t.checkfollowed(t.currentSlideHome);
      // t.getComments();
      t.swiper.on('slideChange', function() {
        console.log(t.swiper.realIndex);
        t.isLoadingLike = false;
        t.currentSlideHome = t.swiper.realIndex;
        t.currentVideoId = t.newsItems[t.currentSlideHome].id;
        // t.checkLiked(t.swiper.realIndex);
        // t.checkfollowed(t.swiper.realIndex);
        // t.getComments();
        if (t.pageHome == 0) {
          if (t.swiper.realIndex == 9 && t.newsItems.length == 10) {
            t.pageHome = 1;
            // t.getPaginatedVideo();
          }
        } else {
          if (
            t.swiper.realIndex == t.newsItems.length - 1 && //19
            t.newsItems.length == (t.pageHome + 1) * 10 //20
          ) {
            t.pageHome += 1;
            // t.getPaginatedVideo();
          }
          // if (
          //   t.swiper.realIndex == t.homeMusic.length - 1 && //19
          //   t.homeMusic.length == (t.pageHome+1)*10 //20
          // ) {
          //   t.pageHome += 1;
          //   t.getPaginatedVideo();
          // }
        }
      });
    },

    tagvalue(tags) {
      return tags.trim().split('#');
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/home-screen.scss';
</style>
